import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SearchIcon, ArrowRightIcon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { useWindows } from '../../contexts/WindowContext';
interface CommandPaletteProps {
  onClose: () => void;
}
export function CommandPalette({
  onClose
}: CommandPaletteProps) {
  const {
    getThemeClasses,
    t
  } = useTheme();
  const {
    openWindow
  } = useWindows();
  const themeClasses = getThemeClasses();
  const [search, setSearch] = useState('');
  const commands = [{
    id: 'about',
    name: 'About Mick',
    action: () => openWindow('about', 'About Mick')
  }, {
    id: 'expertise',
    name: t.apps.expertise || 'Expertise',
    action: () => openWindow('expertise', t.apps.expertise || 'Expertise')
  }, {
    id: 'portfolio',
    name: t.apps.portfolio || 'Portfolio',
    action: () => openWindow('portfolio', t.apps.portfolio || 'Portfolio')
  }, {
    id: 'process',
    name: t.apps.process || 'Process',
    action: () => openWindow('process', t.apps.process || 'Process')
  }, {
    id: 'contact',
    name: t.apps.contact || 'Contact',
    action: () => openWindow('contact', t.apps.contact || 'Contact')
  }, {
    id: 'settings',
    name: t.apps.settings || 'Settings',
    action: () => openWindow('settings', t.apps.settings || 'Settings')
  }];
  const filteredCommands = commands.filter(cmd => cmd.name.toLowerCase().includes(search.toLowerCase()));
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-start justify-center pt-32 px-4" onClick={onClose} data-id="element-671">
      <motion.div initial={{
      scale: 0.9,
      y: -20
    }} animate={{
      scale: 1,
      y: 0
    }} exit={{
      scale: 0.9,
      y: -20
    }} onClick={e => e.stopPropagation()} className={`w-full max-w-2xl ${themeClasses.card} border ${themeClasses.border} rounded-2xl overflow-hidden shadow-2xl`} data-id="element-672">
        <div className="p-4 border-b border-white/10" data-id="element-673">
          <div className="relative" data-id="element-674">
            <SearchIcon className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 ${themeClasses.icon} opacity-50`} data-id="element-675" />
            <input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder={t.commandPalette?.placeholder || 'Type a command or search...'} className={`w-full pl-12 pr-4 py-3 ${themeClasses.card} ${themeClasses.text} placeholder-opacity-50 outline-none text-lg`} autoFocus data-id="element-676" />
          </div>
        </div>
        <div className="max-h-96 overflow-y-auto p-2" data-id="element-677">
          {filteredCommands.map(cmd => <button key={cmd.id} onClick={() => {
          cmd.action();
          onClose();
        }} className={`w-full flex items-center justify-between p-3 rounded-xl ${themeClasses.cardHover} transition-all text-left`} data-id="element-678">
              <span className={`font-medium ${themeClasses.text}`} data-id="element-679">
                {cmd.name}
              </span>
              <ArrowRightIcon className={`w-5 h-5 ${themeClasses.icon} opacity-50`} data-id="element-680" />
            </button>)}
        </div>
      </motion.div>
    </motion.div>;
}